import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import getProductSupersessionProperty from '../themes/gardner-theme/models/getProductSupersessionProperty';
import { SupersessionKey } from '../modules/model-viewer/model-viewer';
import { IAriServiceModelExtension } from '../actions/DataServiceEntities.g';

const GTM_CUSTOM_VARIABLE_LIMIT = 100;

export const buildSearchResultsInventoryList = (products?: ProductSearchResult[]): string => {
    if (!products || !ArrayExtensions.hasElements(products)) {
        return '';
    }

    const values: string[] = [];
    const seenValues = new Set<string>();
    let currentLength = 0;

    for (const product of products) {
        const itemId = product.ItemId;

        if (!itemId) {
            continue;
        }

        const inventory = getProductSupersessionProperty(product, SupersessionKey.Inventory) || '0';
        const value = `${itemId}:${inventory}`;

        if (seenValues.has(value)) {
            continue;
        }

        const separatorLength = values.length > 0 ? 1 : 0;
        const nextLength = currentLength + separatorLength + value.length;

        if (nextLength > GTM_CUSTOM_VARIABLE_LIMIT) {
            break;
        }

        values.push(value);
        seenValues.add(value);
        currentLength = nextLength;
    }

    return values.join('|');
};

export const buildModelResultsList = (models?: IAriServiceModelExtension[]): string => {
    if (!models?.length) {
        return '';
    }

    const values: string[] = [];
    const seenValues = new Set<string>();
    let currentLength = 0;

    for (const model of models) {
        const value = `${model.Id || 'unknown'}:${model.BrandCode || 'unknown'}`;

        if (seenValues.has(value)) {
            continue;
        }

        const separatorLength = values.length > 0 ? 1 : 0;
        const nextLength = currentLength + separatorLength + value.length;

        if (nextLength > GTM_CUSTOM_VARIABLE_LIMIT) {
            break;
        }

        values.push(value);
        seenValues.add(value);
        currentLength = nextLength;
    }

    return values.join('|');
};
